import React, { useState, useEffect } from 'react';
import SelectInput from '../forms/SelectInput';
import FormInput from '../forms/FormInput';
import Button from '../common/Button';
import Card from '../common/Card';
import { categoryService } from '../../services/category.service';
import { theme } from '../../config/theme';

const ProductFilters = ({ filters, onFilterChange, onClearFilters, activeCount }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await categoryService.getAll({ is_active: true });
      setCategories(response.data.categories || []);
    } catch (error) {
      console.error('Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  const categoryOptions = categories.map(cat => ({
    value: cat.id,
    label: cat.name,
  }));

  const featuredOptions = [
    { value: '', label: 'All Products' },
    { value: 'true', label: 'Featured Only' },
    { value: 'false', label: 'Non-Featured' },
  ];

  return (
    <Card padding="lg">
      <div style={{ marginBottom: theme.spacing.lg }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: theme.spacing.md,
        }}>
          <h3 style={{ 
            fontSize: theme.typography.fontSize.lg, 
            fontWeight: theme.typography.fontWeight.semibold,
          }}>
            Filters
          </h3>
          {activeCount > 0 && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={onClearFilters}
            >
              Clear All ({activeCount})
            </Button>
          )}
        </div>
      </div>

      <FormInput
        label="Search"
        name="search"
        placeholder="Search products..."
        value={filters.search || ''}
        onChange={(e) => onFilterChange('search', e.target.value)}
      />

      <SelectInput
        label="Category"
        name="category_id"
        value={filters.category_id || ''}
        onChange={(e) => onFilterChange('category_id', e.target.value)}
        options={categoryOptions}
        placeholder="All Categories"
      />

      <SelectInput
        label="Featured"
        name="is_featured"
        value={filters.is_featured || ''}
        onChange={(e) => onFilterChange('is_featured', e.target.value)}
        options={featuredOptions}
      />

      <div style={{ marginBottom: theme.spacing.lg }}>
        <label style={{ 
          display: 'block',
          marginBottom: theme.spacing.sm,
          fontSize: theme.typography.fontSize.sm,
          fontWeight: theme.typography.fontWeight.medium,
        }}>
          Price Range
        </label>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: theme.spacing.sm }}>
          <FormInput
            name="min_price"
            placeholder="Min"
            type="number"
            value={filters.min_price || ''}
            onChange={(e) => onFilterChange('min_price', e.target.value)}
          />
          <FormInput
            name="max_price"
            placeholder="Max"
            type="number"
            value={filters.max_price || ''}
            onChange={(e) => onFilterChange('max_price', e.target.value)}
          />
        </div>
      </div>
    </Card>
  );
};

export default ProductFilters;